<template>
    <sui-segment basic>
        <h2 class="ui grey right floated header">
            <i class="map icon"></i>
            Administrar Zonas
        </h2>
        <div style="clear: both;"></div>
        <span @click="openAddModal" class="ui right floated primary button"> <i class="plus icon"></i> Agregar zona</span><br><br>
        <div>
            <sui-table color="blue" celled>
                <sui-table-header>
                    <sui-table-row>
                        <sui-table-header-cell>Nombre</sui-table-header-cell>
                        <sui-table-header-cell>Usuarios</sui-table-header-cell>
                        <sui-table-header-cell>Estatus</sui-table-header-cell>
                        <sui-table-header-cell :width="2" textAlign="center"></sui-table-header-cell>
                    </sui-table-row>
                </sui-table-header>
                <sui-table-body>
                    <sui-table-row v-for="zone in zones" :key="zone.id">
                        <td>{{ zone.name }}</td>
                        <td>
                            <div v-if="zone.users && zone.users.length">
                                <div v-for="user in zone.users" :key="user.id" class="zone-user-item">
                                    {{ user.fullName }}
                                    <sui-label v-if="!user.active" color="orange" size="mini"> Inactivo </sui-label>
                                </div>
                            </div>
                            <span v-else class="no-users-text">Sin usuarios</span>
                        </td>
                        <td>
                            <sui-label :color="zone.active ? 'green' : 'orange'">
                                {{ zone.active ? 'Activa' : 'Inactiva' }}
                            </sui-label>
                        </td>
                        <sui-table-cell textAlign="center">
                            <sui-dropdown text="Acciones" button size="mini" color="blue">
                                <sui-dropdown-menu>
                                    <sui-dropdown-item @click="openUsersModal(zone)">
                                        <i class="users icon blue"></i> Usuarios
                                    </sui-dropdown-item>
                                    <sui-dropdown-item @click="updateZone(zone)">
                                        <i :class="zone.active ? 'toggle off icon orange' : 'toggle on icon green'"></i>
                                        {{ zone.active ? 'Desactivar' : 'Activar' }}
                                    </sui-dropdown-item>
                                    <sui-dropdown-item @click="deleteZone(zone)">
                                        <i class="trash icon red"></i> Eliminar
                                    </sui-dropdown-item>
                                </sui-dropdown-menu>
                            </sui-dropdown>
                        </sui-table-cell>
                    </sui-table-row>
                </sui-table-body>
            </sui-table>
        </div>

        <add-zone-modal
            :show-modal="showAddZoneModal"
            :zones="zones"
            @modalResponse="onAddZoneResponse"
        />
        <zone-users-modal
            :show-modal="showUsersModal"
            :zone="selectedZone"
            :zone-users="zoneUsers"
            :available-users-options="availableUsersOptions"
            @add="addUserToZone"
            @remove="removeUserFromZone"
            @close="showUsersModal = false"
        />
    </sui-segment>
</template>

<script>
import GenericService from '@/services/GenericService'
import ZoneService from '@/services/ZoneService'
import Utils from '@/common/Utils'
import AddZoneModal from '@/components/Modals/AddZone.vue'
import ZoneUsersModal from '@/components/Modals/ZoneUsers'

export default {
    name: 'Zones',
    components: { AddZoneModal, ZoneUsersModal },
    data () {
        return {
            zones: [],
            showAddZoneModal: false,
            showUsersModal: false,
            selectedUserId: null,
            selectedZone: null,
            usersInRole: [],
            zoneUsers: [],
            record: {
                name: ''
            }
        }
    },
    beforeMount () {
        if (!this.$store.getters.isLoggedIn) {
            window.location.replace('/login')
        }

        this.fetchZones()
        this.fetchPromoters()
    },
    methods: {
        async fetchZones () {
            const loader = this.$loading.show()
            try {
                let { data } = await GenericService.getAll('/zones')
                this.zones = data
            } finally {
                loader.hide()
            }
        },
        async openAddModal () {
            if (!Utils.userHasPerm('can_manage_zones')) {
                this.$swal({
                    title: 'No tienes permiso para realizar la acción',
                    html: 'Debes solicitar permiso al administrador',
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonText: 'Cerrar'
                })
                return
            }
            this.showAddZoneModal = true
        },
        async addZone () {
            try {
                this.record.name = this.record.name.toUpperCase()
                await GenericService.create('/zones', this.record)
                await this.fetchZones()
                this.record.name = ''
                this.showAddZoneModal = false
            } catch (error) {
                const msg = (error.data || {}).message || 'Hubo un fallo al crear el usuario. Contacta al administrador.'
                this.$swal({
                    icon: 'warning',
                    title: 'Hubo un error',
                    text: msg,
                    timer: 4000,
                    position: 'top',
                    showConfirmButton: false
                })
            }
        },

        async deleteZone (zone) {
            if (!Utils.userHasPerm('can_manage_zones')) {
                this.$swal({
                    title: 'No tienes permiso para realizar la acción',
                    html: 'Debes solicitar permiso al administrador',
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonText: 'Cerrar'
                })
                return
            }

            // validate first if zone is empty
            let data = await ZoneService.getUsersZone(zone.id)

            if (data && data.length > 0) {
                this.$swal({
                    icon: 'warning',
                    title: 'Alerta',
                    text: 'Existen usuarios asignados a esa zona, no se puede eliminar.',
                    position: 'top',
                    showConfirmButton: true
                })
                return
            }

            this.$swal({
                title: `¿Estas seguro que deseas eliminar la zona ${zone.name}?`,
                html: 'Una vez realizada la acción, no se puede revertir',
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, eliminar',
                cancelButtonText: 'No, cancelar'
            }).then(async result => {
                if (result.value) {
                    await GenericService.executeAction('/zones/delete', zone)
                    await this.fetchZones()
                }
            })
        },

        async updateZone (zone) {
            if (!Utils.userHasPerm('can_manage_zones')) {
                this.$swal({
                    title: 'No tienes permiso para realizar la acción',
                    html: 'Debes solicitar permiso al administrador',
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonText: 'Cerrar'
                })
                return
            }

            const status = (zone.active) ? 'Desactivar' : 'Activar'
            this.$swal({
                title: `¿Estas seguro que deseas ${status} la zona?`,
                html: ` ${zone.name}`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si',
                cancelButtonText: 'No, cancelar'
            }).then(async result => {
                if (result.value) {
                    await GenericService.executeAction('/zones/disable', zone)
                    await this.fetchZones()
                }
            })
        },

        async fetchZoneUsers () {
            const loader = this.$loading.show()
            try {
                const data = await ZoneService.getUsersZone(this.selectedZone.id)
                this.zoneUsers = data
            } finally {
                loader.hide()
            }
        },

        async addUserToZone (userId) {
            try {
                await ZoneService.assignUser({ zoneId: this.selectedZone.id, userId })
                await Promise.all([this.fetchZoneUsers(), this.fetchPromoters(), this.fetchZones()])
            } catch (error) {
                const msg = (error.data || {}).message || 'No se pudo agregar el usuario a la zona.'
                this.$swal({
                    icon: 'warning',
                    title: 'Hubo un error',
                    text: msg,
                    timer: 4000,
                    position: 'top',
                    showConfirmButton: false
                })
            }
        },

        async removeUserFromZone (user) {
            if (!Utils.userHasPerm('can_manage_zones')) {
                this.$swal({
                    title: 'No tienes permiso para realizar la acción',
                    html: 'Debes solicitar permiso al administrador',
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonText: 'Cerrar'
                })
                return
            }

            const result = await this.$swal({
                title: `¿Quitar a ${user.fullName} de la zona?`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, quitar',
                cancelButtonText: 'Cancelar'
            })

            if (result.value) {
                await ZoneService.removeUser({
                    zoneId: this.selectedZone.id,
                    userId: user.id
                })

                await Promise.all([
                    this.fetchZoneUsers(),
                    this.fetchPromoters(),
                    this.fetchZones()
                ])
            }
        },

        async fetchPromoters () {
            const loader = this.$loading.show()
            try {
                const { data } = await GenericService.getAll('/users', { roleName: 'PROMOTOR FLORESER', active: true })
                this.usersInRole = (data.items || []).sort((a, b) => a.fullName.localeCompare(b.fullName))
            } catch (error) {
                console.error(error)
            } finally {
                loader.hide()
            }
        },

        async onAddZoneResponse (record) {
            if (record.cancel) {
                this.showAddZoneModal = false
                return
            }
            try {
                await GenericService.create('/zones', { name: record.name.toUpperCase() })
                await this.fetchZones()
                this.showAddZoneModal = false
            } catch (error) {
                const msg = (error.data || {}).message || 'Hubo un fallo al crear la zona. Contacta al administrador.'
                this.$swal({ icon: 'warning', title: 'Hubo un error', text: msg, timer: 4000, position: 'top', showConfirmButton: false })
            }
        },

        async openUsersModal (zone) {
            this.selectedZone = zone
            this.showUsersModal = true
            await this.fetchZoneUsers()
        }
    },

    computed: {
        isDuplicateZoneName () {
            if (!this.record.name.trim()) return false
            return this.zones.some(
                zone => zone.name.trim().toLowerCase() === this.record.name.trim().toLowerCase()
            )
        },

        availableUsersOptions () {
            return this.usersInRole
                .filter(u => !u.zoneId)
                .map(u => ({ text: u.fullName, value: u.id }))
        }
    }
}
</script>

<style scoped>
.zone-user-item {
    margin-bottom: 4px;
}

.no-users-text {
    color: #999;
}
</style>
